import { render } from "./selectColeccion.vue?vue&type=template&id=12722480"
import script from "./selectColeccion.vue?vue&type=script&lang=ts"
export * from "./selectColeccion.vue?vue&type=script&lang=ts"
script.render = render

export default script